const dismissedSessionNoticeKeys = new Set<string>();

export const getSessionNoticeKey = (noticeId: string, userId?: number) => {
  return `${noticeId}:${String(userId)}`;
};

export const isSessionNoticeDismissed = (noticeKey: string) => {
  return dismissedSessionNoticeKeys.has(noticeKey);
};

export const dismissSessionNotice = (noticeKey: string) => {
  dismissedSessionNoticeKeys.add(noticeKey);
};

export const resetSessionNoticeDismissals = () => {
  dismissedSessionNoticeKeys.clear();
};
